export default {
  title: 'Datos del gestor'
}
